<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p>
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">审核状态</div>
              <div class="itemNum jishi">{{ orderInvalidForm.auditStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单编号</div>
              <div class="itemNum">{{ form.id }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">申请人</div>
              <div class="itemNum">{{ orderInvalidForm.applyStaffIdCn }}</div>
            </div>
            <div class="flex-row mb30" v-if="orderInvalidForm.auditStatus == 'wait'">
              <div class="itemName">申请时间</div>
              <div class="itemNum">{{ form.oxCtime }}</div>
            </div>
            <div class="flex-row mb30" v-else-if="orderInvalidForm.auditStatus == 'pass'">
              <div class="itemName">通过时间</div>
              <div class="itemNum">{{ form.oxLtime }}</div>
            </div>
            <div class="flex-row mb30" v-else>
              <div class="itemName">拒绝时间</div>
              <div class="itemNum">{{ form.oxLtime }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">支付状态</div>
              <div class="itemNum">{{ form.payStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">支付方式</div>
              <div class="itemNum">{{ form.payWayCn }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单明细</i></p>
          <div class="totals-box">
            <div class="plr16">
              <el-table :data="form.orderItemVOList" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="itemName" label="商品名称" width="auto"></el-table-column>
                <el-table-column prop="staffNames" label="服务技师" width="auto"></el-table-column>
                <el-table-column prop="realPayAmount" label="金额" width="80"></el-table-column>
                <el-table-column prop="itemNum" label="数量" width="80"></el-table-column>
              </el-table>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>支付金额</i></p>
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">总金额</div>
              <div class="itemNum">￥{{ form.orderAmount ? form.orderAmount : 0}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">折扣金额</div>
              <div class="itemNum">￥{{ form.discountAmount ? form.discountAmount : 0}}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实付总金额</div>
              <div class="itemNum moneys">￥{{ form.realPayAmount ? form.realPayAmount : 0}}</div>
            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10" v-perm="{key:'orderInvaild', value:'orderInvaild:audit'}">
          <div class="btns" v-if="orderInvalidForm.auditStatus == 'wait'">
            <el-button type="danger" class="small-btn" @click="onRefuse('refuse')">拒绝</el-button>
            <el-button type="primary" class="small-btn" @click="onRefuse('pass')">同意</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "作废详情",
      addEditShow: false,
      form: {
        mobile: ""
      },
      orderInvalidForm: {}
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api
          .get(this.$url.orderInfo.get, {
            id: org.orderId
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.form.oxLtime = this.formatDate(this.form.oxLtime);
            }
          });
        this.$api
          .get(this.$url.orderInvalid.get, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.orderInvalidForm = res;
              this.orderInvalidForm.oxCtime = this.formatDate(
                this.orderInvalidForm.oxCtime
              );
            }
          });
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onRefuse(status) {
      this.$confirm(status == "pass" ? "确定同意吗?" : "确定拒绝吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.orderInvalid.audit, {
              id: this.orderInvalidForm.id,
              auditStatus: status
            })
            .then(res => {
              if (res) {
                this.$message.success(status == "pass" ? "作废审核同意" : "作废审核拒绝");
                this.addEditShow = false;
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    onPass(values) {
      this.$api
        .post(this.$url.shopRechargeApply.save, this.form)
        .then(res => {
          if (res) {
            this.addEditShow = false;
            this.$emit("change", true);
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}

.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .totals-box {
    // padding: 0.2rem 0;
    .detail {
      // padding: 0 20px;
      // font-size: 0.18rem;
      .rows {
        // margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-between;
        // align-items: flex-end;
        // display: flex;
        align-items: center;
        justify-content: space-between;
        height: 52px;
        padding: 10px 26px;
        box-sizing: border-box;
        color: #8d8d8d;
        border-bottom: 1px solid @borderColor;
        .amount {
          font-size: 0.3rem;
        }
        div {
          color: #ff892a;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .pay-methods {
    padding: 0.3rem;
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }
    .active {
      // background-image: url('../../assets/images/money/gou.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: @blue;
    }
  }
}
/deep/ .el-message-box__wrapper {
  position: relative;
  z-index: 9999 !important;
}
</style>